import { useUser } from '@clerk/clerk-react'
import { useConfigVersionRevalidator } from '@/hooks/useConfigVersionRevalidator'

/**
 * Mounts the route-change revalidator hook inside the RouterProvider tree.
 *
 * Why this is a separate component (not part of CacheBootstrapProvider):
 *   `useConfigVersionRevalidator` calls `useLocation()`, which throws unless
 *   it runs inside `<RouterProvider>`. CacheBootstrapProvider sits ABOVE the
 *   router (it's inside `Providers`, which wraps `<RouterProvider>` in
 *   `app/root.tsx`). So we split the hook into its own component and mount
 *   it inside `Layout` instead — Layout is rendered as a route element and
 *   therefore has the router context.
 *
 * Renders nothing.
 */
export function ConfigVersionRevalidator(): null {
  const { user, isLoaded } = useUser()
  useConfigVersionRevalidator(isLoaded && !!user)
  return null
}
